import { t as e } from "../../chunks/index.es.CfT5btWg.js";
import { Fragment as t, jsx as n } from "react/jsx-runtime";
//#region lib/List/components/List.tsx
var r = ({ element: r, children: i, rootNode: a }) => {
	let o = e.isElement(a) && a?.properties?.editable === !1 ? !1 : void 0;
	return /* @__PURE__ */ n(t, { children: r.type === "core/ordered-list" ? /* @__PURE__ */ n("ol", {
		role: "list",
		contentEditable: o,
		className: "pl-10 m-0 py-2 font-serif list-decimal",
		children: i
	}) : /* @__PURE__ */ n("ul", {
		role: "list",
		contentEditable: o,
		className: "pl-10 m-0 py-2 font-serif list-disc",
		children: i
	}) });
};
//#endregion
export { r as List };
